const store = {
    namespaced: true,
    state: {
      accountTransaction: null,
      details: null,
      claim: null,
      ready: false,
    },
    getters: {
    },
    actions: {
      async load({state, commit}, data) {
        commit("setReady", false);
        let details = null;
        let claim = null;
        let t = this.state.transactions.transactions;
        let cardProcessor = this.state.participant ? this.state.participant.cardProcessor : data.cardProcessor;
        if(!cardProcessor) cardProcessor = data.cardProcessor;
        let transaction = cardProcessor == 1 ? t.find(x => x.transactionKey == data.transactionKey) : 
         t.find(x=>x.accountTransactionId == data.accountTransactionId);
        
        let detailsKey = cardProcessor == 1 ? data.transactionKey : data.accountTransactionId;

        let detailsUrl = `/participant/${data.participantId}/transaction/${detailsKey}/detail`;
        let claimUrl = `/participant/${data.participantId}/claim/${data.transactionKey}`;
        
        if(transaction.wcaRawData){ // WCA transaction data only
          details = Object.entries(transaction.wcaRawData)
            .map(x => { return { key:x[0], value:x[1] }});
              
          await Promise.all([romeApi.get(detailsUrl), romeApi.get(claimUrl)])
          .then(([detailsResult, claimResult]) => {
            claim = claimResult;
            details = details.concat(detailsResult);
          });
        } else { // FD transaction data only
          await Promise.all([romeApi.get(detailsUrl), romeApi.get(claimUrl)])
            .then(([detailsResult, claimResult]) => {
              claim = claimResult;
              details = detailsResult;
            });
        }

        commit("setTransaction", transaction);
        commit("setTransactionDetail", details);
        commit("setClaim", claim);
        commit("setReady", true);
      },
    },
    mutations: {
      setTransaction(state, transaction) {
        state.accountTransaction = transaction;
      },
      setTransactionDetail(state, details) {
        state.details = details;
      },
      setClaim(state, claim) {
        state.claim = claim;
      },
      setReady(state, ready) {
        state.ready = ready
      },
    }
  };
  
  export default store;


// WEBPACK FOOTER //
// ./src/transactions/x-transaction.js